
import firebase from 'firebase'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/auth'
 

// firebase init goes here
 

 

  const firebaseConfig = {
  apiKey: "AIzaSyAGLVAB3hb4UY4o1xwvIATfu14HkpE2XgY",
  authDomain: "sayra-a4201.firebaseapp.com",
 databaseURL: "https://sayra-a4201.firebaseio.com",

  projectId: "sayra-a4201",
  storageBucket: "sayra-a4201.appspot.com",
  messagingSenderId: "963406811828",
  appId: "1:963406811828:web:632efd93c8c91bbbd67de1"
};



  // Initialize Firebase
 firebase.initializeApp(firebaseConfig);
 

 
const db = firebase.firestore()
const storage = firebase.storage()
const auth = firebase.auth()
 

 

// date issue fix according to firebase
 
 console.log('firebase')
 

export {
    db,
    storage,
    auth
}


// WEBPACK FOOTER //
// ./src/firebaseconfig.js